<template>
  <tr class="clickable">
    <td>
      {{ base.name }}
    </td>
    <td>
      {{ base.address }}
    </td>
    <td>
      {{ base.country.name }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'BaseRow',
    props: {
      base: {
        type: Object,
        default: null
      }
    }
  }
</script>
